import React from 'react';
import Navbar from '../shared/Navbar';
import Island from '../shared/Island';

import './index.css';
import CTACard from '../shared/CTACard';
import { poliglotLink } from '../../classes/poliglotlink';
import Title from '../shared/Title';
import { palette, breakpoints } from '../../constants/styles';
import Footer from '../landing/Footer';
import styled from 'styled-components';

const StyledRouterBody = styled.div`
  margin-top: 80px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${breakpoints.tablet} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export default function index() {
  return (
    <div className="router-container">
      <Navbar />
      <StyledRouterBody>
        <CTACard
          showRightArrow
          teaser="Descubre con cuánto te retirarás"
          title="Calcula tu retiro"
          leftPoliglotLink={
            new poliglotLink('/retiro/res/73/44b8ba40', false, true, 'Ver ejemplo', null)
          }
          rightPoliglotLink={new poliglotLink('/retiro', false, true, 'Ir', null)}
          color={palette.sweetPurple}
        />
        <CTACard
          showRightArrow
          teaser="Mejora tu pensión"
          title="Plan de pensión"
          leftPoliglotLink={
            new poliglotLink('https://finauta.s3.us-east-2.amazonaws.com/products/Plan+de+pensio%CC%81n+-+Ejemplo.pdf', true, false, 'Ver ejemplo', null)
          }
          rightPoliglotLink={new poliglotLink('https://www.finauta.com/plan-de-pension', false, false, "Ir")}
          color={palette.primaryColor}
        />
        <CTACard
          showRightArrow
          teaser="Retoma el control de tus finanzas"
          title="Plan financiero"
          leftPoliglotLink={
            new poliglotLink('/plan/res/7314/preview', false, true, 'Ver ejemplo', null)
          }
          rightPoliglotLink={new poliglotLink('/plan', false, true, 'Ir', null)}
          color={palette.terciaryColorShy}
        />
      </StyledRouterBody>
      <Footer />
    </div>
  );
}
